
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class SimulationBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class SimulationBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    return {
      id:          'simulation',
      seq:         parseInt(data.seq),
      name:        `${args.title} [ ${data.a.trace_start} - ${data.a.trace_end} ]`,
      hasChildren: args.hasChildren,
      isExpanded:  args.isExpanded,
      type:        'simulation',
      children:    args.children,
      parent:      args.parent,
      kids:        data.ch,
      tags:        data.tg,
      label:       'simulation',
      pkey:        '',
      args:        data.a,
      options:     data.a
    };
  }
}
